import React from 'react';
import { Flex, Heading, Icon, Text, Box } from 'pounceV2';
import { WRITING_RULES_DOC_URL } from 'Source/constants';
import { Panel } from 'reactflow';
import { LinkButtonV3 } from 'Components/buttons/LinkButton';
import { useTheme } from '@mui/material';

const EditorEmptyMessageV3 = () => {
  const {
    palette: { tokens },
  } = useTheme();
  return (
    <Panel position="top-center" style={{ margin: '0' }}>
      <Flex align="center" direction="column" gap={6} mt={6}>
        <Box backgroundColor={tokens.background.accent[3][5]} borderRadius="circle" p={4}>
          <Icon color={tokens.background.accent[3].base} type="sparkle-book" size="large" />
        </Box>
        <Heading textAlign="center">You haven’t added any rules yet!</Heading>
        <Flex direction="column" gap={2}>
          <Text fontSize="large" textAlign="center" lineHeight="loose">
            Build your rule in the YAML editor to start building your correlation rule.
          </Text>
        </Flex>
        <LinkButtonV3 variant="ghost" external size="medium" to={WRITING_RULES_DOC_URL}>
          Panther Documentation <Icon ml={2} type="external-link" size="medium" />
        </LinkButtonV3>
      </Flex>
    </Panel>
  );
};

export default EditorEmptyMessageV3;
